import moment from "moment";
import React, { useState } from "react";
import { Edit, Trash } from "react-feather";
import toast from "react-hot-toast";
import { Badge, Button, UncontrolledTooltip } from "reactstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CustomDataTable from "../../../common/CustomDataTable";
import {
  useDeleteDeductionListMutation,
  useGetDeductionListQuery,
} from "../../../redux/deductionList";
import DeductionListModal from "./DeductionListModal";

const MySwal = withReactContent(Swal);

const DeductionList = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [deleteDeductionList] = useDeleteDeductionListMutation();

  const handleConfirmDelete = (id, name) => {
    return MySwal.fire({
      title: `Delete Item ${name}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger ms-1",
      },
      buttonsStyling: false,
    }).then(async (result) => {
      if (result.value) {
        const responseStatus = await deleteDeductionList(id);
        if (responseStatus) {
          toast.success("Item has been Deleted.");
        }
      }
    });
  };

  const handleEditClick = (data) => {
    setSelectedRow(data);
    setIsModalVisible(true);
  };

  const columns = [
    {
      name: "Description",
      sortField: "description",
      sortable: true,
      selector: (row) => (
        <div className="text-truncate" style={{ maxWidth: "250px" }}>
          {row.description}
        </div>
      ),
    },
    {
      sortable: true,
      name: "Amount",
      cell: ({ amount }) => amount,
    },
    {
      sortable: true,
      name: "Rate",
      cell: ({ amountType }) => amountType,
    },
    {
      sortable: true,
      name: "Basis",
      cell: ({ basis }) => basis?.name || "Gross",
    },
    {
      sortable: true,
      name: "User",
      cell: ({ createdBy }) => createdBy?.username,
    },
    {
      sortable: true,
      name: "Created Date",
      selector: (row) => row.createdAt,
      cell: ({ createdAt }) => moment(createdAt).format("DD/MM/YYYY"),
      sortFunction: (rowA, rowB) =>
        new Date(rowB.createdAt) - new Date(rowA.createdAt),
    },
    {
      name: "Status",
      sortable: true,
      cell: (row) => (
        <Badge
          color={row.status == "active" ? "success" : "danger"}
          className="text-capitalize"
        >
          <span>{row.status}</span>
        </Badge>
      ),
      selector: (row) => row.status,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex align-items-center permissions-actions">
          <Button
            id="update-btn"
            size="sm"
            color="transparent"
            className="btn btn-icon"
            onClick={() => handleEditClick(row)}
          >
            <Edit className="font-medium-2" />
            <UncontrolledTooltip placement="top" target="update-btn">
              Update
            </UncontrolledTooltip>
          </Button>
          <Button
            id="delete-btn"
            size="sm"
            color="transparent"
            className="btn btn-icon"
            onClick={() => handleConfirmDelete(row._id, row.description)}
          >
            <Trash className="font-medium-2 text-danger" />
            <UncontrolledTooltip placement="top" target="delete-btn">
              Delete
            </UncontrolledTooltip>
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <CustomDataTable
        columns={columns}
        title="Deduction List"
        fetchData={useGetDeductionListQuery}
        query={{}}
        searchFields={["name", "description"]}
        populate={[
          {
            path: "basis",
            dir: "hrm/salaryTypes",
            select: "name",
          },
          {
            path: "createdBy",
            dir: "users",
            select: "username name",
          },
        ]}
        buttonLabel={"Add New"}
        addButtonClick={() => setIsModalVisible(true)}
      />
      <DeductionListModal
        selectedRow={selectedRow}
        show={isModalVisible}
        setShow={setIsModalVisible}
        setSelectedRow={setSelectedRow}
      />
    </div>
  );
};

export default DeductionList;
